<template>
  <div>
    <div class="menu">
      <div class="identification">
        <div class="identification-img ">
          <img src="@/assets/images/login-circle.png" alt="" />
        </div>
        <div style="margin-left: 15px;" v-if="showTitle">
          双派智能
        </div>
      </div>

      <el-menu background-color="#000" text-color="#eee" active-text-color="#4dbcff" :default-active="currentMenu"
        class="el-menu-vertical-demo" :collapse="isCollapse" :collapse-transition="false" unique-opened ref="menu">
        <template v-for="v in sidebarMenu">
          <el-submenu :index="v.name" v-if="v.children && v.children.length > 0" :key="v.name">
            <template slot="title">
              <img class="icon-imgs" :src="v.meta.icon" alt="">
              <span slot="#title">{{ v.meta.name }}</span>
            </template>
            <el-menu-item-group>
              <menu-component :menuData="v.children"></menu-component>
            </el-menu-item-group>
          </el-submenu>

          <el-menu-item :key="v.name" :index="v.name" @click="gotoRoute(v)" v-else-if="v.type != 1 && v.type != 2">
            <img class="icon-imgs" :src="v.meta.icon" alt="">
            <span slot="title">{{ v.meta.name }}</span>
          </el-menu-item>
        </template>
      </el-menu>
    </div>
  </div>
</template>

<script>
import MenuComponent from "../../menu/index.vue"; // 确保正确导入路径
import { mapState } from "vuex";

export default {
  components: {
    MenuComponent,
  },
  data() {
    return {
      // isCollapse: false,
      showTitle: false, // 控制文字显示
      titleTimer: null  // 定时器标识
    };
  },
  computed: {
    ...mapState("premissions", ["sidebarMenu", "currentMenu", "isCollapse"]),
  },
  created() {
    if (!this.isCollapse) {
      this.showTitle = true;
    }
  },
  // 监听折叠状态变化
  watch: {
    isCollapse(newVal) {
      // 清除之前的定时器，防止多次触发
      clearTimeout(this.titleTimer);

      if (!newVal) {
        // 展开时，延迟200ms显示文字（可自定义时间）
        this.titleTimer = setTimeout(() => {
          this.showTitle = true;
        }, 300);
      } else {
        // 折叠时，立即隐藏文字
        this.showTitle = false;
      }
    }
  },
  // 销毁组件时清除定时器
  beforeDestroy() {
    clearTimeout(this.titleTimer);
  },
  methods: {
    gotoRoute(v) {
      // 🔥 关闭所有打开的菜单
      this.$refs.menu.openedMenus = []
      this.$router.push({
        name: v.name,
      }); 
    },
  },
};
</script>

<style lang="less" scoped>
.menu {
  height: 100%;

  .identification {
    height: 100px;
    display: flex;
    align-items: center;
    justify-content: center;

    color: #fff;
    font-size: 17px;
    font-weight: bold;

    .identification-img {
      width: 50px;
      height: 50px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: rgba(255, 255, 255, .2);
      border-radius: 8px;

      img {
        width: 30px;
        height: 30px;
      }
    }
  }

  /deep/ .el-menu--collapse {
    width: 100%;
    text-align: center;
  }

  /deep/ .el-menu-item.is-active {
    background: #1677ff !important;
    color: #fff !important;
  }

  /deep/ .el-menu-item {
    height: 48px;
    line-height: 48px;
  }

  /deep/ .el-menu {
    border: 0;
  }

  /deep/ .el-menu-item,
  .el-submenu__title {
    height: 48px;
    line-height: 48px;
    display: flex;
    align-items: center;
  }


}


/deep/ .el-menu-item-group__title {
  display: none;
}

.icon-imgs {
  width: 20px;
  height: 20px;
  margin-right: 10px;
}
</style>